import request from 'utils/request'

export const getMCAXS541InitRequest = () =>
  request({
    url: '/MCAXS541/init',
    method: 'post',
  })
